var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            show: function($event) {
              return _vm.clearQuestions()
            },
            hide: function($event) {
              return _vm.hideQuestionModal()
            }
          },
          model: {
            value: _vm.add_question,
            callback: function($$v) {
              _vm.add_question = $$v
            },
            expression: "add_question"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideQuestionModal()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("question")) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c("div", { staticClass: "col-xs-10 col-sm-10" }, [
                      _c("p", { staticClass: "caption" }, [
                        _vm._v(_vm._s(_vm.$t("title")))
                      ])
                    ]),
                    _c(
                      "div",
                      { staticClass: "col-xs-2 col-sm-2" },
                      [
                        _vm.id_question === 0
                          ? _c("q-btn", {
                              attrs: {
                                small: "",
                                label: _vm.$t("import_questions_database")
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showQuestionsDataBaseModal()
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-12" },
                      [
                        _c("q-editor", {
                          attrs: {
                            error: _vm.$v.title.$error,
                            toolbar: [
                              ["bold", "italic", "strike", "underline"],
                              ["left", "center", "right", "justify"],
                              ["link", "upload"],
                              [
                                {
                                  label: null,
                                  icon: "fas fa-font",
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: "no-icons",
                                  options: [
                                    "p",
                                    "h1",
                                    "h2",
                                    "h3",
                                    "h4",
                                    "h5",
                                    "h6",
                                    "code"
                                  ]
                                },
                                {
                                  label: null,
                                  icon: "fas fa-text-height",
                                  fixedLabel: true,
                                  fixedIcon: true,
                                  list: "no-icons",
                                  options: [
                                    "size-1",
                                    "size-2",
                                    "size-3",
                                    "size-4",
                                    "size-5",
                                    "size-6",
                                    "size-7"
                                  ]
                                },
                                "removeFormat"
                              ],
                              ["quote", "unordered", "ordered"]
                            ],
                            definitions: {
                              bold: { label: null, icon: "fas fa-bold" },
                              italic: { label: null, icon: "fas fa-italic" },
                              strike: {
                                label: null,
                                icon: "fas fa-strikethrough"
                              },
                              underline: {
                                label: null,
                                icon: "fas fa-underline"
                              },
                              left: { label: null, icon: "fas fa-align-left" },
                              center: {
                                label: null,
                                icon: "fas fa-align-center"
                              },
                              right: {
                                label: null,
                                icon: "fas fa-align-right"
                              },
                              justify: {
                                label: null,
                                icon: "fas fa-align-justify"
                              },
                              link: { label: null, icon: "fas fa-link" },
                              upload: {
                                tip: null,
                                icon: "fas fa-file-image",
                                handler: _vm.insertImg
                              },
                              removeFormat: {
                                label: null,
                                icon: "fas fa-eraser"
                              },
                              quote: {
                                label: null,
                                icon: "fas fa-quote-right"
                              },
                              unordered: {
                                label: null,
                                icon: "fas fa-list-ul"
                              },
                              ordered: { label: null, icon: "fas fa-list-ol" }
                            }
                          },
                          on: { input: _vm.$v.title.$touch },
                          model: {
                            value: _vm.title,
                            callback: function($$v) {
                              _vm.title = $$v
                            },
                            expression: "title"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("q-table", {
                    staticClass: "q-mt-lg",
                    attrs: {
                      data: _vm.alternatives,
                      columns: _vm.columns,
                      pagination: _vm.server_pagination,
                      loading: _vm.loading,
                      "row-key": "id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [0],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.server_pagination = $event
                      },
                      request: _vm.request_alternatives
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "q-table-title" }, [
                              _vm._v(_vm._s(_vm.$t("alternatives")))
                            ]),
                            _c("div", { staticClass: "col" }),
                            _c("q-btn", {
                              attrs: {
                                color: "secondary",
                                icon: "far fa-plus",
                                label: _vm.$t("new_f"),
                                disable: _vm.has_results
                              },
                              on: {
                                click: function($event) {
                                  return _vm.addAlternative()
                                }
                              }
                            })
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                { key: col.name, attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n                            "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            {
                              attrs: { props: props },
                              on: {
                                click: function($event) {
                                  return _vm.addAlternative()
                                }
                              }
                            },
                            [
                              _c(
                                "q-td",
                                {
                                  key: "is_correct",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c("q-radio", {
                                    attrs: {
                                      val: true,
                                      disable: _vm.has_results
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.changeCorrect(props.row)
                                      }
                                    },
                                    model: {
                                      value: props.row.is_correct,
                                      callback: function($$v) {
                                        _vm.$set(props.row, "is_correct", $$v)
                                      },
                                      expression: "props.row.is_correct"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "title", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        props.row.title.substring(0, 100)
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "actions",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        round: "",
                                        color: "primary",
                                        icon: "far fa-pencil-alt"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.editAlternative(props.row)
                                        }
                                      }
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(
                                              _vm.$t("view_or_edit_tooltip")
                                            ) +
                                            "\n                                    "
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        flat: "",
                                        round: "",
                                        color: "negative",
                                        icon: "far fa-trash-alt",
                                        disable: _vm.has_results
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removeAlternative(
                                            props.row
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(_vm.$t("delete_tooltip")) +
                                            "\n                                    "
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("p", { staticClass: "caption" }, [
                            _vm._v(_vm._s(_vm.$t("mandatory")))
                          ]),
                          _c("q-btn-toggle", {
                            attrs: {
                              "toggle-color": _vm.getColorIsMandatoryButton,
                              options: _vm.is_mandatory_options
                            },
                            model: {
                              value: _vm.is_mandatory,
                              callback: function($$v) {
                                _vm.is_mandatory = $$v
                              },
                              expression: "is_mandatory"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "far fa-block"
                            },
                            on: {
                              click: function($event) {
                                return _vm.hideQuestionModal()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save"),
                              icon: "far fa-save"
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveQuestion()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          attrs: { preventClose: "" },
          on: {
            ok: function($event) {
              return _vm.saveAlternative()
            },
            hide: function($event) {
              return _vm.clearAlternative()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.add_alternative = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: "positive",
                      label: _vm.$t("add_alternative")
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveAlternative()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.add_alternative,
            callback: function($$v) {
              _vm.add_alternative = $$v
            },
            expression: "add_alternative"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("add_alternative")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("alternative")))
          ]),
          _c(
            "span",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-editor", {
                attrs: {
                  toolbar: [
                    ["bold", "italic", "strike", "underline"],
                    ["left", "center", "right", "justify"],
                    ["link", "upload"],
                    [
                      {
                        label: null,
                        icon: "fas fa-font",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "p",
                          "h1",
                          "h2",
                          "h3",
                          "h4",
                          "h5",
                          "h6",
                          "code"
                        ]
                      },
                      {
                        label: null,
                        icon: "fas fa-text-height",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "size-1",
                          "size-2",
                          "size-3",
                          "size-4",
                          "size-5",
                          "size-6",
                          "size-7"
                        ]
                      },
                      "removeFormat"
                    ],
                    ["quote", "unordered", "ordered"]
                  ],
                  definitions: {
                    bold: { label: null, icon: "fas fa-bold" },
                    italic: { label: null, icon: "fas fa-italic" },
                    strike: { label: null, icon: "fas fa-strikethrough" },
                    underline: { label: null, icon: "fas fa-underline" },
                    left: { label: null, icon: "fas fa-align-left" },
                    center: { label: null, icon: "fas fa-align-center" },
                    right: { label: null, icon: "fas fa-align-right" },
                    justify: { label: null, icon: "fas fa-align-justify" },
                    link: { label: null, icon: "fas fa-link" },
                    upload: {
                      tip: null,
                      icon: "fas fa-file-image",
                      handler: _vm.insertImg
                    },
                    removeFormat: { label: null, icon: "fas fa-eraser" },
                    quote: { label: null, icon: "fas fa-quote-right" },
                    unordered: { label: null, icon: "fas fa-list-ul" },
                    ordered: { label: null, icon: "fas fa-list-ol" }
                  }
                },
                model: {
                  value: _vm.new_alternative,
                  callback: function($$v) {
                    _vm.new_alternative = $$v
                  },
                  expression: "new_alternative"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { preventClose: "" },
          on: {
            hide: function($event) {
              return _vm.clearAlternative()
            }
          },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: {
                      color: "positive",
                      label: _vm.$t("edit_alternative")
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveEditAlternative()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.edit_alternative,
            callback: function($$v) {
              _vm.edit_alternative = $$v
            },
            expression: "edit_alternative"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("edit_alternative")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("alternative")))
          ]),
          _c(
            "span",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-editor", {
                attrs: {
                  toolbar: [
                    ["bold", "italic", "strike", "underline"],
                    ["left", "center", "right", "justify"],
                    ["link", "upload"],
                    [
                      {
                        label: null,
                        icon: "fas fa-font",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "p",
                          "h1",
                          "h2",
                          "h3",
                          "h4",
                          "h5",
                          "h6",
                          "code"
                        ]
                      },
                      {
                        label: null,
                        icon: "fas fa-text-height",
                        fixedLabel: true,
                        fixedIcon: true,
                        list: "no-icons",
                        options: [
                          "size-1",
                          "size-2",
                          "size-3",
                          "size-4",
                          "size-5",
                          "size-6",
                          "size-7"
                        ]
                      },
                      "removeFormat"
                    ],
                    ["quote", "unordered", "ordered"]
                  ],
                  definitions: {
                    bold: { label: null, icon: "fas fa-bold" },
                    italic: { label: null, icon: "fas fa-italic" },
                    strike: { label: null, icon: "fas fa-strikethrough" },
                    underline: { label: null, icon: "fas fa-underline" },
                    left: { label: null, icon: "fas fa-align-left" },
                    center: { label: null, icon: "fas fa-align-center" },
                    right: { label: null, icon: "fas fa-align-right" },
                    justify: { label: null, icon: "fas fa-align-justify" },
                    link: { label: null, icon: "fas fa-link" },
                    upload: {
                      tip: null,
                      icon: "fas fa-file-image",
                      handler: _vm.insertImg
                    },
                    removeFormat: { label: null, icon: "fas fa-eraser" },
                    quote: { label: null, icon: "fas fa-quote-right" },
                    unordered: { label: null, icon: "fas fa-list-ul" },
                    ordered: { label: null, icon: "fas fa-list-ol" }
                  }
                },
                model: {
                  value: _vm.alternative.title,
                  callback: function($$v) {
                    _vm.$set(_vm.alternative, "title", $$v)
                  },
                  expression: "alternative.title"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            show: function($event) {
              return _vm.clearSelectedQuestion()
            },
            hide: function($event) {
              return _vm.clearSelectedQuestion()
            }
          },
          model: {
            value: _vm.search_questions_database_modal,
            callback: function($$v) {
              _vm.search_questions_database_modal = $$v
            },
            expression: "search_questions_database_modal"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.search_questions_database_modal = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.$t("question")) +
                        "\n                    "
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-12" },
                    [
                      _c(
                        "q-input",
                        {
                          attrs: {
                            "float-label":
                              _vm.$t("titles") +
                              ": " +
                              _vm.$t("training") +
                              ", " +
                              _vm.$t("test") +
                              ", " +
                              _vm.$t("question"),
                            clearable: ""
                          },
                          on: {
                            clear: function($event) {
                              return _vm.clearSelectedQuestion()
                            }
                          },
                          model: {
                            value: _vm.search_questions_list,
                            callback: function($$v) {
                              _vm.search_questions_list = $$v
                            },
                            expression: "search_questions_list"
                          }
                        },
                        [
                          _c("q-autocomplete", {
                            attrs: {
                              "max-results": 25,
                              "min-characters": 3,
                              "value-field": function(v) {
                                return (
                                  v.id +
                                  " - " +
                                  v.presential_event_test_question_title
                                )
                              }
                            },
                            on: {
                              search: _vm.searchQuestionsDataBase,
                              selected: _vm.selectQuestionDataBase
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm.selected_question.presential_event_title !== ""
                  ? _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("training")) + ": ")
                        ]),
                        _vm._v(
                          _vm._s(_vm.selected_question.presential_event_title) +
                            "\n                        "
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [_vm._v(_vm._s(_vm.$t("test")) + ":  ")]),
                        _vm._v(
                          _vm._s(
                            _vm.selected_question.presential_event_test_title
                          ) + "\n                        "
                        )
                      ]),
                      _c("div", { staticClass: "col-xs-12 col-sm-12" }, [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("question")) + ":  ")
                        ]),
                        _vm._v(
                          _vm._s(
                            _vm.selected_question
                              .presential_event_test_question_title
                          ) + "\n                        "
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-12" },
                        [
                          _c(
                            "q-table",
                            {
                              staticClass: "q-mt-lg",
                              attrs: {
                                data: _vm.selected_question.alternatives,
                                columns: _vm.select_question_columns,
                                "row-key": "id",
                                "binary-state-sort": ""
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "header",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        { attrs: { props: props } },
                                        _vm._l(props.cols, function(col) {
                                          return _c(
                                            "q-th",
                                            {
                                              key: col.name,
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.$t(col.label)) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        }),
                                        1
                                      )
                                    }
                                  },
                                  {
                                    key: "body",
                                    fn: function(props) {
                                      return _c(
                                        "q-tr",
                                        {
                                          attrs: { props: props },
                                          on: {
                                            click: function($event) {
                                              return _vm.addAlternative()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "q-td",
                                            {
                                              key: "is_correct",
                                              attrs: {
                                                "auto-width": "",
                                                props: props
                                              }
                                            },
                                            [
                                              _c("q-radio", {
                                                attrs: {
                                                  val: true,
                                                  disable: true
                                                },
                                                on: {
                                                  input: function($event) {
                                                    return _vm.changeCorrect(
                                                      props.row
                                                    )
                                                  }
                                                },
                                                model: {
                                                  value: props.row.is_correct,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      props.row,
                                                      "is_correct",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "props.row.is_correct"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "q-td",
                                            {
                                              key: "title",
                                              attrs: { props: props }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(
                                                    props.row.title.substring(
                                                      0,
                                                      100
                                                    )
                                                  ) +
                                                  "\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    }
                                  }
                                ],
                                null,
                                false,
                                4032909504
                              )
                            },
                            [
                              _c("template", { slot: "top" }, [
                                _c("div", { staticClass: "q-table-title" }, [
                                  _vm._v(_vm._s(_vm.$t("alternatives")))
                                ]),
                                _c("div", { staticClass: "col" })
                              ])
                            ],
                            2
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "row gutter-sm justify-end q-mt-lg" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            icon: "far fa-block",
                            label: _vm.$t("cancel")
                          },
                          on: {
                            click: function($event) {
                              _vm.search_questions_database_modal = false
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            icon: "far fa-file-import",
                            label: _vm.$t("import"),
                            disable:
                              _vm.selected_question
                                .presential_event_test_question_title === ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmSelectedQuestion()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }